import React, { useEffect, useState } from "react";
import { referralsApi } from "@/lib/api";
import { Trophy, Users } from "lucide-react";

export default function LandingLeaderboard() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    referralsApi.publicLeaderboard(5).then((r) => setRows(r.leaderboard || [])).catch(() => setRows([]));
  }, []);

  if (!rows) return null;

  return (
    <section className="relative z-10 px-6 lg:px-12 py-10 max-w-6xl mx-auto">
      <div className="aq-card-glass p-6 border-white/10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-emerald-300 flex items-center gap-2">
              <Trophy className="w-3 h-3" /> Live leaderboard
            </div>
            <div className="font-display text-xl font-bold mt-1">Top referrers on TradingoX right now</div>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 hidden sm:flex items-center gap-1">
            <Users className="w-3 h-3" /> Bring-a-friend match · 7 fee-free days each
          </div>
        </div>
        {rows.length === 0 ? (
          <div className="text-sm text-slate-400 font-mono">Be the first to refer a friend and take rank #1.</div>
        ) : (
          <div className="grid sm:grid-cols-5 gap-2">
            {rows.map((r, i) => (
              <div
                key={r.referral_code}
                className={`rounded-lg p-3 border ${i === 0 ? "border-amber-500/40 bg-amber-500/10" : "border-white/10 bg-white/5"}`}
              >
                <div className={`font-mono text-[10px] uppercase tracking-[0.25em] ${i === 0 ? "text-amber-300" : "text-slate-500"}`}>
                  Rank #{i + 1}
                </div>
                <div className="mt-1 font-display font-bold truncate text-slate-100">{r.display_name}</div>
                <div className="mt-1 font-mono text-[11px] text-slate-400">
                  <span className="text-emerald-300 font-bold">{r.referrals_converted}</span> converted ·
                  <span className="ml-1 text-slate-300">{r.referrals_joined}</span> joined
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
